import { FC } from 'react';
import { StyledNumber } from './NumberText.styles';
import { NumberTextProps } from './NumberText.types';
import { Sizes, Weights } from '@/common/types';

/**
 * @param size Default size value is Medium
 * @param weight Default weight value is Regular
 * @returns A formatted number converted into an english local string
 */
const NumberText: FC<NumberTextProps> = ({ css, children, size = Sizes.MEDIUM, testId, weight = Weights.REGULAR }) => {
  return (
    <StyledNumber css={{ ...css }} data-testid={testId} size={size} weight={weight}>
      {isNaN(Number(children)) ? children : Number(children).toLocaleString('en')}
    </StyledNumber>
  );
};

export default NumberText;
